import type { ExchangeProjectContextBriefDto } from '@inference.engine/api-client';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@monksflow/monks-ui';
import { BriefSnapshotPreview } from './BriefSnapshotPreview';

interface Props {
  brief: ExchangeProjectContextBriefDto | null;
  onClose: () => void;
}

/**
 * Previews a brief snapshot frozen onto a sent message. Briefs are live
 * documents, so this renders the exact point-in-time content the message
 * carried rather than re-fetching the (possibly-changed) source brief. Sized to
 * match the Library brief preview so a brief reads the same wherever it opens.
 */
export function BriefSnapshotPreviewDialog(props: Props) {
  return (
    <Dialog open={!!props.brief} onOpenChange={(open) => !open && props.onClose()}>
      <DialogContent className="flex h-[90vh] w-[min(calc(100vw-2rem),64rem)] flex-col gap-0 overflow-hidden p-0">
        <DialogHeader className="border-b border-border p-4">
          <DialogTitle className="text-base font-medium text-foreground">
            {props.brief?.title}
          </DialogTitle>
        </DialogHeader>
        <div className="flex min-h-0 flex-1 flex-col overflow-auto p-6">
          {props.brief && <BriefSnapshotPreview brief={props.brief} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
